import React, { useMemo } from 'react';
import moment from 'moment';
// @ts-ignore: TS2459 — we know it's there at runtime
import { DailyPerformanceCard } from '@PikaDoApp/pikado-web-dsm';

export interface StudentDailyPerformanceItem {
  day: number;
  studentDailyAnswersCount: number;
  dailyAverage: number;
  date: string;
}

interface StudentDailyPerformanceContainerProps {
  studentDailyPerformanceList: StudentDailyPerformanceItem[];
  selectedMonth: string;
  onMonthChange: (month: string) => void;
  monthOptions: Array<{label: string; value: string}>;
}

export const StudentDailyPerformanceContainer: React.FC<StudentDailyPerformanceContainerProps> = ({
  studentDailyPerformanceList,
  selectedMonth,
  onMonthChange,
  monthOptions,
}) => {
  const dailyPerformanceData = useMemo(() => {
    const dataMap = new Map<number, number>();

    if (studentDailyPerformanceList && studentDailyPerformanceList.length > 0) {
      studentDailyPerformanceList.forEach((item) => {
        if (item.day) {
          // Use dailyAverage from the data and ensure it's a valid, finite number
          const average = Number.isFinite(item.dailyAverage) ? item.dailyAverage : 0;
          dataMap.set(item.day, average);
        }
      });
    }

    // Generate all 31 days, filling missing days with 0
    const allDays = [];
    for (let day = 1; day <= 31; day++) {
      allDays.push({
        date: day.toString(),
        performance: dataMap.get(day) || 0,
      });
    }

    return allDays;
  }, [studentDailyPerformanceList]);

  return (
    <DailyPerformanceCard
      dailyPerformanceData={dailyPerformanceData}
      title="Daily Performance This Month"
      monthOptions={monthOptions}
      selectedMonth={selectedMonth}
      onMonthChange={onMonthChange}
    />
  );
};
